import { useGetSchedulesByItemIds } from '@/features/settings/work-integrations/queries/useGetSchedules';
import { workIntegrationsQueryKeys } from '@/features/settings/work-integrations/queryKeys';
import { usePublishedContext } from '@/features/views/components/published/PublishedContext';
import { usePublishedSnapshotQuery } from '@/features/views/components/published/usePublishedSnapshotQuery';

export const useSchedulesQueryWithPublished = (itemId: number, enabled = true) => {
  const publishedContext = usePublishedContext();
  const isPublished = publishedContext !== null;

  const schedulesQuery = useGetSchedulesByItemIds([itemId], undefined, !isPublished && enabled);

  const publishedQuery = usePublishedSnapshotQuery({
    baseKey: workIntegrationsQueryKeys.scheduleByItemId(itemId),
    getSnapshot: () => {
      if (!publishedContext) return undefined;
      const schedule = publishedContext.getItemPanelData(itemId)?.schedule;
      return schedule ? { [itemId]: { itemId, ...schedule } } : {};
    },
  });

  return isPublished ? publishedQuery : schedulesQuery;
};
